
import React from 'react';
import AnimatedSection from './AnimatedSection';
import SectionHeading from './SectionHeading';
import { GraduationCap, Award } from 'lucide-react';

const educations = [
  {
    degree: 'Bachelor of Science, Data Science and Applications',
    institution: 'Indian Institute of Technology Madras · Online degree',
    date: 'Apr 2022 - Dec 2025',
    details: 'GPA: 8.04/10',
    subjects: [
      'Machine Learning', 'Deep Learning', 'MLOps', 'Data Structures & Algorithms', 'Software Engineering', 'Database Systems'
    ]
  },
  {
    degree: 'Bachelor of Technology, Information Technology',
    institution: 'Anna University',
    date: 'Jan 2019 - May 2023',
    details: 'GPA: 9.28/10 | Department Topper, University 9th Rank',
    subjects: [
      'Operating Systems', 'Computer Networks', 'Cloud Computing', 'Distributed Systems', 'Data Structures & Algorithms', 'Cryptography'
    ]
  }
];

export default function Education() {
  return (
    <AnimatedSection id="education">
      <SectionHeading number={3}>Education</SectionHeading>
      <div className="grid md:grid-cols-2 gap-8">
        {educations.map((edu, index) => (
          <div
            key={index}
            className="p-6 rounded-xl transition-all duration-300 hover:-translate-y-1"
            style={{ background:'rgba(15,23,42,0.7)', border:'1px solid rgba(30,41,59,0.7)', backdropFilter:'blur(8px)', boxShadow:'0 4px 24px rgba(0,0,0,0.3)' }}
          >
            <div className="flex items-start justify-between mb-4">
              <GraduationCap className="w-10 h-10 text-teal-300" />
              <p className="font-mono text-sm text-slate-500 text-right">{edu.date}</p>
            </div>
            <h3 className="text-lg font-bold text-slate-100">{edu.degree}</h3>
            <p className="text-md text-slate-400 mb-2">{edu.institution}</p>
            <div className="flex items-center gap-2 font-mono text-xs text-teal-300 bg-teal-400/10 px-3 py-1 rounded-full mb-4">
              <Award className="w-4 h-4" />
              <span>{edu.details}</span>
            </div>

            {/* Render subjects */}
            <div>
              <p className="text-teal-300 font-mono text-xs uppercase mb-1">Relevant Coursework:</p>
              <ul className="list-disc list-inside text-slate-400 text-sm space-y-1">
                {edu.subjects.map((subject, i) => (
                  <li key={i}>{subject}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </AnimatedSection>
  );
}
